import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/ATH LOGOs/logo1.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-top">
        <div className="logo">
          <img src={logo} alt="Atlas Travels" className="logo-img" />
        </div>

        <ul className={`nav-links ${isOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={toggleMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/events" onClick={toggleMenu}>
              Events
            </Link>
          </li>
          <li>
            <Link to="/mice" onClick={toggleMenu}>
              MICE Vertical
            </Link>
          </li>
              <li>
                <span className="newBadge">NEW </span>
  <Link
    to="/venue-planner"
    onClick={toggleMenu}
    style={{ background: "transparent" }}
  >
   Venue Planner
  </Link>
</li>
          <li>
            <Link to="/packages" onClick={toggleMenu}>
              Packages
            </Link>
          </li>
           <li>
            <Link to="/visa" onClick={toggleMenu}>
              Visa
            </Link>
          </li>
           <li>
            <Link to="/rnr" onClick={toggleMenu}>
              RnR
            </Link>
          </li>
          <li>
            <Link to="/Blog" onClick={toggleMenu}>
              Blog
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={toggleMenu}>
              About Us
            </Link>
          </li>
          

         
         
          <li>
            <Link to="/contact" onClick={toggleMenu}>
              Contact / FeedBack
            </Link>
          </li>
      
        </ul>

        <div
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <h2 className="subheading">
        Subsidiary Group of Amoha Hospitality Pvt Ltd
      </h2>
    </nav>
  );
}

export default Navbar;
